import {singleton} from "../decorators/singleton";

@singleton
export class BaseTerms {
  static injectables = [];
}
